import { vSelect } from '@desislavsd/vue-select'
export default {
  vSelect
}



// WEBPACK FOOTER //
// ./src/app/auth/active/tenant/resources/components.js